import { HttpHeaders } from '@angular/common/http';

export function getHeaders(idOrganizacion: string, idUsuario: string, requestOrigin: string): HttpHeaders {
    const headers = new HttpHeaders()
      .set("IDOrganizacion", idOrganizacion)
      // .set("IDOrganization", idOrganizacion)
      .set("IDUsuario", idUsuario)
      .set("RequestOrigin", requestOrigin)

    return headers
}